"use client";
import { RefObject } from "react";
import styles from "./modals.module.css";
import { useLocale, useTranslations } from "next-intl";
import { MdClose } from "react-icons/md";
import { useMyListingsStore } from "../../../useMyListingsStore";
import { useUserAuthDataContext } from "@/global-context/user-auth-context";

export default function DeleteModal({
  dialogRef,
  handleClose,
}: {
  dialogRef: RefObject<HTMLDivElement | null>;
  handleClose: () => void;
}) {
  const t = useTranslations("SoldModal");
  const { deleteState, state, deleteListing } = useMyListingsStore();
  const listingId = deleteState.listingState?.listing_id;
  const listingTitle = state.listings.find(
    (l) => l.listing_id === listingId,
  )?.title;
  const locale = useLocale();
  const { userData } = useUserAuthDataContext();
  return (
    <div
      ref={dialogRef}
      className={styles.contentWrapper}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className={styles.closeButton}
        onClick={(e) => {
          e.preventDefault();
          handleClose();
        }}
      >
        <MdClose />
      </button>
      <h3>Are you sure you want to delete this listing?</h3>
      <p className={styles.description}>
        This action will permanently remove <b>{truncate(30, listingTitle)}</b>{" "}
        from Doomum. You won’t be able to restore it once it’s deleted.
      </p>
      <p className={styles.info}>
        You can always create a new listing later if needed.
      </p>
      <p className={styles.step}>{t("step", { stepNumber: "2/2" })}</p>
      <div className={styles.buttonsWrapper}>
        <button
          className={styles.btnPrimary}
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("no")}
        </button>
        <button
          className={styles.btn}
          onClick={(e) => {
            e.preventDefault();
            handleClose();
            deleteListing(locale, userData.sessionId);
          }}
        >
          {t("yes")}
        </button>
      </div>
    </div>
  );
}

function truncate(maxLength: number, text?: string | null) {
  if (!text) return "";
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trim() + "…";
}
